import { getParameterByName } from './urlUtils';
import _ from 'lodash';

export const LANGUAGES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'pt', label: 'Português', flag: '🇵🇹' },
  { code: 'nl', label: 'Nederlands', flag: '🇳🇱' },
  { code: 'aa', label: 'Qafar af', flag: '🇩🇯' },
  { code: 'ab', label: 'Аҧсуа', flag: '🇬🇪' },
  { code: 'af', label: 'Afrikaans', flag: '🇿🇦' },
  { code: 'ak', label: 'Akan', flag: '🇬🇭' },
  { code: 'am', label: 'አማርኛ', flag: '🇪🇹' },
  { code: 'an', label: 'Aragonés', flag: '🇪🇸' },
  { code: 'ar', label: 'العربية', flag: '🇸🇦' },
  { code: 'as', label: 'অসমীয়া', flag: '🇮🇳' },
  { code: 'av', label: 'Авар мацӀ', flag: '🇷🇺' },
  { code: 'ae', label: 'Avesta', flag: '🇮🇷' },
  { code: 'ay', label: 'Aymar aru', flag: '🇧🇴' },
  { code: 'az', label: 'Azərbaycan dili', flag: '🇦🇿' },
  { code: 'ba', label: 'Башҡорт теле', flag: '🇷🇺' },
  { code: 'be', label: 'Беларуская', flag: '🇧🇾' },
  { code: 'bg', label: 'Български', flag: '🇧🇬' },
  { code: 'bi', label: 'Bislama', flag: '🇻🇺' },
  { code: 'bm', label: 'Bamanankan', flag: '🇲🇱' },
  { code: 'bn', label: 'বাংলা', flag: '🇧🇩' },
  { code: 'bo', label: 'བོད་ཡིག', flag: '🇨🇳' },
  { code: 'br', label: 'Brezhoneg', flag: '🇫🇷' },
  { code: 'bs', label: 'Bosanski', flag: '🇧🇦' },
  { code: 'ca', label: 'Català', flag: '🇪🇸' },
  { code: 'ce', label: 'Нохчийн мотт', flag: '🇷🇺' },
  { code: 'ch', label: 'Chamoru', flag: '🇬🇺' },
  { code: 'co', label: 'Corsu', flag: '🇫🇷' },
  { code: 'cr', label: 'ᓀᐦᐃᔭᐍᐏᐣ', flag: '🇨🇦' },
  { code: 'cs', label: 'Čeština', flag: '🇨🇿' },
  { code: 'cu', label: 'Словѣньскъ', flag: '🇷🇺' },
  { code: 'cv', label: 'Чăвашла', flag: '🇷🇺' },
  { code: 'cy', label: 'Cymraeg', flag: '🇬🇧' },
  { code: 'da', label: 'Dansk', flag: '🇩🇰' },
  { code: 'dv', label: 'ދިވެހި', flag: '🇲🇻' },
  { code: 'dz', label: 'རྫོང་ཁ', flag: '🇧🇹' },
  { code: 'ee', label: 'Eʋegbe', flag: '🇬🇭' },
  { code: 'el', label: 'Ελληνικά', flag: '🇬🇷' },
  { code: 'eo', label: 'Esperanto', flag: '🌐' },
  { code: 'et', label: 'Eesti', flag: '🇪🇪' },
  { code: 'eu', label: 'Euskara', flag: '🇪🇸' },
  { code: 'fa', label: 'فارسی', flag: '🇮🇷' },
  { code: 'ff', label: 'Fulfulde', flag: '🇸🇳' },
  { code: 'fi', label: 'Suomi', flag: '🇫🇮' },
  { code: 'fj', label: 'Vosa Vakaviti', flag: '🇫🇯' },
  { code: 'fo', label: 'Føroyskt', flag: '🇫🇴' },
  { code: 'fy', label: 'Frysk', flag: '🇳🇱' },
  { code: 'ga', label: 'Gaeilge', flag: '🇮🇪' },
  { code: 'gd', label: 'Gàidhlig', flag: '🇬🇧' },
  { code: 'gl', label: 'Galego', flag: '🇪🇸' },
  { code: 'gn', label: "Avañe'ẽ", flag: '🇵🇾' },
  { code: 'gu', label: 'ગુજરાતી', flag: '🇮🇳' },
  { code: 'gv', label: 'Gaelg', flag: '🇮🇲' },
  { code: 'ha', label: 'Hausa', flag: '🇳🇬' },
  { code: 'he', label: 'עברית', flag: '🇮🇱' },
  { code: 'hi', label: 'हिन्दी', flag: '🇮🇳' },
  { code: 'ho', label: 'Hiri Motu', flag: '🇵🇬' },
  { code: 'hr', label: 'Hrvatski', flag: '🇭🇷' },
  { code: 'ht', label: 'Kreyòl ayisyen', flag: '🇭🇹' },
  { code: 'hu', label: 'Magyar', flag: '🇭🇺' },
  { code: 'hy', label: 'Հայերեն', flag: '🇦🇲' },
  { code: 'hz', label: 'Otjiherero', flag: '🇳🇦' },
  { code: 'ia', label: 'Interlingua', flag: '🌐' },
  { code: 'id', label: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'ie', label: 'Interlingue', flag: '🌐' },
  { code: 'ig', label: 'Igbo', flag: '🇳🇬' },
  { code: 'ii', label: 'ꆇꉙ', flag: '🇨🇳' },
  { code: 'ik', label: 'Iñupiaq', flag: '🇺🇸' },
  { code: 'io', label: 'Ido', flag: '🌐' },
  { code: 'is', label: 'Íslenska', flag: '🇮🇸' },
  { code: 'iu', label: 'ᐃᓄᒃᑎᑐᑦ', flag: '🇨🇦' },
  { code: 'ja', label: '日本語', flag: '🇯🇵' },
  { code: 'jv', label: 'Basa Jawa', flag: '🇮🇩' },
  { code: 'ka', label: 'ქართული', flag: '🇬🇪' },
  { code: 'kg', label: 'Kikongo', flag: '🇨🇩' },
  { code: 'ki', label: 'Gĩkũyũ', flag: '🇰🇪' },
  { code: 'kj', label: 'Kuanyama', flag: '🇳🇦' },
  { code: 'kk', label: 'Қазақ тілі', flag: '🇰🇿' },
  { code: 'kl', label: 'Kalaallisut', flag: '🇬🇱' },
  { code: 'km', label: 'ភាសាខ្មែរ', flag: '🇰🇭' },
  { code: 'kn', label: 'ಕನ್ನಡ', flag: '🇮🇳' },
  { code: 'ko', label: '한국어', flag: '🇰🇷' },
  { code: 'kr', label: 'Kanuri', flag: '🇳🇬' },
  { code: 'ks', label: 'कॉशुर', flag: '🇮🇳' },
  { code: 'ku', label: 'Kurdî', flag: '🇮🇶' },
  { code: 'kv', label: 'Коми кыв', flag: '🇷🇺' },
  { code: 'kw', label: 'Kernewek', flag: '🇬🇧' },
  { code: 'ky', label: 'Кыргызча', flag: '🇰🇬' },
  { code: 'la', label: 'Latina', flag: '🇻🇦' },
  { code: 'lb', label: 'Lëtzebuergesch', flag: '🇱🇺' },
  { code: 'lg', label: 'Luganda', flag: '🇺🇬' },
  { code: 'li', label: 'Limburgs', flag: '🇳🇱' },
  { code: 'ln', label: 'Lingála', flag: '🇨🇩' },
  { code: 'lo', label: 'ລາວ', flag: '🇱🇦' },
  { code: 'lt', label: 'Lietuvių', flag: '🇱🇹' },
  { code: 'lu', label: 'Kiluba', flag: '🇨🇩' },
  { code: 'lv', label: 'Latviešu', flag: '🇱🇻' },
  { code: 'mg', label: 'Malagasy', flag: '🇲🇬' },
  { code: 'mh', label: 'Kajin M̧ajeļ', flag: '🇲🇭' },
  { code: 'mi', label: 'Te Reo Māori', flag: '🇳🇿' },
  { code: 'mk', label: 'Македонски', flag: '🇲🇰' },
  { code: 'ml', label: 'മലയാളം', flag: '🇮🇳' },
  { code: 'mn', label: 'Монгол', flag: '🇲🇳' },
  { code: 'mr', label: 'मराठी', flag: '🇮🇳' },
  { code: 'ms', label: 'Bahasa Melayu', flag: '🇲🇾' },
  { code: 'mt', label: 'Malti', flag: '🇲🇹' },
  { code: 'my', label: 'မြန်မာဘာသာ', flag: '🇲🇲' },
  { code: 'na', label: 'Dorerin Naoero', flag: '🇳🇷' },
  { code: 'nb', label: 'Norsk bokmål', flag: '🇳🇴' },
  { code: 'nd', label: 'isiNdebele', flag: '🇿🇼' },
  { code: 'ne', label: 'नेपाली', flag: '🇳🇵' },
  { code: 'ng', label: 'Owambo', flag: '🇳🇦' },
  { code: 'nn', label: 'Norsk nynorsk', flag: '🇳🇴' },
  { code: 'no', label: 'Norsk', flag: '🇳🇴' },
  { code: 'nr', label: 'isiNdebele', flag: '🇿🇦' },
  { code: 'nv', label: 'Diné bizaad', flag: '🇺🇸' },
  { code: 'ny', label: 'Chichewa', flag: '🇲🇼' },
  { code: 'oc', label: 'Occitan', flag: '🇫🇷' },
  { code: 'oj', label: 'Anishinaabemowin', flag: '🇨🇦' },
  { code: 'om', label: 'Afaan Oromoo', flag: '🇪🇹' },
  { code: 'or', label: 'ଓଡ଼ିଆ', flag: '🇮🇳' },
  { code: 'os', label: 'Ирон', flag: '🇷🇺' },
  { code: 'pa', label: 'ਪੰਜਾਬੀ', flag: '🇮🇳' },
  { code: 'pi', label: 'पालि', flag: '🇮🇳' },
  { code: 'pl', label: 'Polski', flag: '🇵🇱' },
  { code: 'ps', label: 'پښتو', flag: '🇦🇫' },
  { code: 'qu', label: 'Runa Simi', flag: '🇵🇪' },
  { code: 'rm', label: 'Rumantsch', flag: '🇨🇭' },
  { code: 'rn', label: 'Ikirundi', flag: '🇧🇮' },
  { code: 'ro', label: 'Română', flag: '🇷🇴' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
  { code: 'rw', label: 'Ikinyarwanda', flag: '🇷🇼' },
  { code: 'sa', label: 'संस्कृतम्', flag: '🇮🇳' },
  { code: 'sc', label: 'Sardu', flag: '🇮🇹' },
  { code: 'sd', label: 'سنڌي', flag: '🇵🇰' },
  { code: 'se', label: 'Davvisámegiella', flag: '🇳🇴' },
  { code: 'sg', label: 'Sängö', flag: '🇨🇫' },
  { code: 'si', label: 'සිංහල', flag: '🇱🇰' },
  { code: 'sk', label: 'Slovenčina', flag: '🇸🇰' },
  { code: 'sl', label: 'Slovenščina', flag: '🇸🇮' },
  { code: 'sm', label: 'Gagana Samoa', flag: '🇼🇸' },
  { code: 'sn', label: 'chiShona', flag: '🇿🇼' },
  { code: 'so', label: 'Soomaali', flag: '🇸🇴' },
  { code: 'sq', label: 'Shqip', flag: '🇦🇱' },
  { code: 'sr', label: 'Српски', flag: '🇷🇸' },
  { code: 'ss', label: 'siSwati', flag: '🇸🇿' },
  { code: 'st', label: 'Sesotho', flag: '🇱🇸' },
  { code: 'su', label: 'Basa Sunda', flag: '🇮🇩' },
  { code: 'sv', label: 'Svenska', flag: '🇸🇪' },
  { code: 'sw', label: 'Kiswahili', flag: '🇹🇿' },
  { code: 'ta', label: 'தமிழ்', flag: '🇮🇳' },
  { code: 'te', label: 'తెలుగు', flag: '🇮🇳' },
  { code: 'tg', label: 'Тоҷикӣ', flag: '🇹🇯' },
  { code: 'th', label: 'ไทย', flag: '🇹🇭' },
  { code: 'ti', label: 'ትግርኛ', flag: '🇪🇷' },
  { code: 'tk', label: 'Türkmençe', flag: '🇹🇲' },
  { code: 'tl', label: 'Filipino', flag: '🇵🇭' },
  { code: 'tn', label: 'Setswana', flag: '🇧🇼' },
  { code: 'to', label: 'lea fakatonga', flag: '🇹🇴' },
  { code: 'tr', label: 'Türkçe', flag: '🇹🇷' },
  { code: 'ts', label: 'Xitsonga', flag: '🇿🇦' },
  { code: 'tt', label: 'Татар теле', flag: '🇷🇺' },
  { code: 'tw', label: 'Twi', flag: '🇬🇭' },
  { code: 'ty', label: 'Reo Tahiti', flag: '🇵🇫' },
  { code: 'ug', label: 'ئۇيغۇرچە', flag: '🇨🇳' },
  { code: 'uk', label: 'Українська', flag: '🇺🇦' },
  { code: 'ur', label: 'اردو', flag: '🇵🇰' },
  { code: 'uz', label: 'Oʻzbek', flag: '🇺🇿' },
  { code: 've', label: 'Tshivenḓa', flag: '🇿🇦' },
  { code: 'vi', label: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'vo', label: 'Volapük', flag: '🌐' },
  { code: 'wa', label: 'Walon', flag: '🇧🇪' },
  { code: 'wo', label: 'Wolof', flag: '🇸🇳' },
  { code: 'xh', label: 'isiXhosa', flag: '🇿🇦' },
  { code: 'yi', label: 'ייִדיש', flag: '🇮🇱' },
  { code: 'yo', label: 'Yorùbá', flag: '🇳🇬' },
  { code: 'za', label: 'Vahcuengh', flag: '🇨🇳' },
  { code: 'zh', label: '中文', flag: '🇨🇳' },
  { code: 'zu', label: 'isiZulu', flag: '🇿🇦' },
];

const languageByCode = _.keyBy(LANGUAGES, 'code');

function resolveLanguageOption(code, override) {
  const known = languageByCode[code];

  return {
    value: code,
    label: known?.label || code.toUpperCase(),
    shortLabel: code.toUpperCase(),
    flag: (override && typeof override.flag === 'string' ? override.flag : null) || known?.flag || '🌐',
  };
}

export function getLanguageOptions(languages) {
  if (!languages) return [];

  if (Array.isArray(languages)) {
    return languages.map((code) => resolveLanguageOption(code));
  }
  return [];
}

export function getCurrentLanguage() {
  const urlLang = getParameterByName('lang');
  if (urlLang) return urlLang;

  const { lang } = window.__DATA__ || {};
  if (typeof lang === 'string') return lang;
  if (Array.isArray(lang) && lang.length) return lang[0];

  return 'fr';
}

export function setLanguageUrlParam(lang) {
  const url = new URL(window.location.href);
  url.searchParams.set('lang', lang);
  return url.toString();
}
